/**
 * Graphql mutation to create event
 * @module src/graphql/submitInventoryRequest
 */
import gql from 'graphql-tag';

/** creating event */

const SUBMIT_INVENTORY_REQUEST = gql`
  mutation submitInventoryRequest(
    $caseId: String
    $caseExternalId: String
    $accountId: String
    $branchId: String
    $salesRepId: String
    $shipToId: String
    $serviceLevel: String
    $needByDate: Date
    $shipMethod: String
    $requestedFrom: String
    $eventType: String
    $comments: [Comment]
    $lineItems: [SubmitInventoryRequestLineItems]
    $expectedCaseVersion: String
    $system: String
    $version: String
  ) {
    submitInventoryRequest(
      caseId: $caseId
      caseExternalId: $caseExternalId
      accountId: $accountId
      branchId: $branchId
      salesRepId: $salesRepId
      shipToId: $shipToId
      serviceLevel: $serviceLevel
      needByDate: $needByDate
      shipMethod: $shipMethod
      requestedFrom: $requestedFrom
      eventType: $eventType
      lineItems: $lineItems
      comments: $comments
      expectedCaseVersion: $expectedCaseVersion
      system: $system
      version: $version
    ) {
      message
      externalId
      submissionId
      status
    }
  }
`;

export default SUBMIT_INVENTORY_REQUEST;
